"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../../../chunks/clsx-CBkIpawf.js");
const description = "_description_1hx23_1";
const styles = {
  description,
  "description-error": "_description-error_1hx23_9",
  "description-default": "_description-default_1hx23_13"
};
const Description = ({ children, variant, ...props }) => {
  return /* @__PURE__ */ jsxRuntime.jsx("span", { className: clsx.clsx(styles.description, styles[`description-${variant}`]), ...props, children });
};
exports.Description = Description;
